import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MeetingDisplayItem } from "./model/model.class";
import { Parameters } from './model/model.class';
import { SharedService } from './shared.service';

@Component({
  selector: 'meeting-info',
  templateUrl: './meeting-info.component.html',
  styleUrls: ['./meeting-info.component.css']
})
export class MeetingInfoComponent {
  @Input() item: MeetingDisplayItem;    
  @Input() parameters: Parameters;
  @Input() showCloseButton: boolean = false;

  @Output() close = new EventEmitter<void>(); 

  constructor(private sharedService: SharedService) { }

  onClose(): void {
    this.close.emit();
  }

  getImageUrl(iconName: string): string {
    return this.sharedService.getImageUrl(iconName);
  }

  getImageStatus(item: MeetingDisplayItem): string {
    return this.sharedService.getImageStatus(item);
  }
  

  getOriginDescription(item: MeetingDisplayItem): string {
    return this.sharedService.getOriginDescription(item);
  }

  getEventTypeDescription(item: MeetingDisplayItem): string {
    return this.sharedService.getEventTypeDescription(item);
  }

  formatTime(date: string): string {
    return this.sharedService.formatTime(date);
  }


}



// WEBPACK FOOTER //
// ./src/app/meeting-info.component.ts